import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardUserController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardUserController.php
* @route '/api/template-dashboard-user/{template_dashboard_user}'
*/
const UpdateTemplateDashboardUserController = (args: { template_dashboard_user: string | number | { id: string | number } } | [template_dashboard_user: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTemplateDashboardUserController.url(args, options),
    method: 'put',
})

UpdateTemplateDashboardUserController.definition = {
    methods: ["put"],
    url: '/api/template-dashboard-user/{template_dashboard_user}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardUserController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardUserController.php
* @route '/api/template-dashboard-user/{template_dashboard_user}'
*/
UpdateTemplateDashboardUserController.url = (args: { template_dashboard_user: string | number | { id: string | number } } | [template_dashboard_user: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template_dashboard_user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { template_dashboard_user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            template_dashboard_user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template_dashboard_user: typeof args.template_dashboard_user === 'object'
        ? args.template_dashboard_user.id
        : args.template_dashboard_user,
    }

    return UpdateTemplateDashboardUserController.definition.url
            .replace('{template_dashboard_user}', parsedArgs.template_dashboard_user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardUserController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardUserController.php
* @route '/api/template-dashboard-user/{template_dashboard_user}'
*/
UpdateTemplateDashboardUserController.put = (args: { template_dashboard_user: string | number | { id: string | number } } | [template_dashboard_user: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTemplateDashboardUserController.url(args, options),
    method: 'put',
})

export default UpdateTemplateDashboardUserController